const dropdown = {
  btns: document.querySelectorAll('.jsDropdownTrigger') as NodeListOf<
    HTMLElement
  >,
  dropdowns: document.querySelectorAll('.jsDropdown'),
  wrap: document.querySelectorAll('.jsDropdownWrap'),
  curent: 0,

  init() {
    this.setDropdown()
   this.clickOutside()
  },

  setDropdown() {
    this.btns.forEach((item, index) => {
      item.addEventListener('click', () => {
        if (item.dataset.open === 'false') {
          this.closeAll()
          item.dataset.open = 'true'
          item.classList.add('activeClass')
          this.dropdowns[index].classList.add('activeClass')
      
        } else {
          item.classList.remove('activeClass')
          this.dropdowns[index].classList.remove('activeClass')
          item.dataset.open = 'false'
          this.closeAll()
        }
      })
    })
  },
  closeAll() {
    this.btns.forEach((item, index) => {
      item.classList.remove('activeClass')
      this.dropdowns[index].classList.remove('activeClass')
      item.dataset.open = 'false'
    })
  },
  clickOutside() {

      window.addEventListener('click', (e) => {
          let inside = false;
          this.wrap.forEach(item => {
              if (item.contains(e.target as HTMLElement)) {
                  inside = true
                  return inside;
              }

          })
          if (!inside) {
              this.btns.forEach((item, index) => {
                  item.classList.remove('activeClass');
                  this.dropdowns[index].classList.remove('activeClass');

              })

          }

       })
  }
}

export default dropdown
